export default __webpack_public_path__ + "static/media/menu1.99645ad4.mp3";